module.exports = __webpack_public_path__ + "img/safari-icon-72.93a13704.png";